module.exports = __webpack_public_path__ + "img/282.8a372e04.jpg";